module.exports = __webpack_public_path__ + "img/ioms_logo_footer.a2b96ae1.svg";